import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconTrashBin = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <rect width={14} height={17} x={5} y={5} stroke="currentColor" strokeWidth={2} rx={1} />
    <rect width={18} height={2} x={3} y={4} fill="currentColor" rx={1} />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9 4c0-2.5 6-2.5 6 0"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10 9v9M14 9v9"
    />
  </NcIcon>
);
export { NcIconTrashBin };
